import React from 'react';
import { Checkbox, FloatingDropdown } from 'wix-ui-tpa/cssVars';
import type { FloatingDropdownOptionProps } from 'wix-ui-tpa';
import { classes } from './FilterDropdown.st.css';
import { FilterOption } from '../../../../types/types';
import { FilterDropdownDataHooks } from './const';

export type FilterDropdownProps = {
  label: string;
  options: FilterOption[];
  onChange: (selectedOption: FilterOption) => void;
  dataHook?: string;
  filterByText: string;
};

export const FilterDropdown: React.FC<FilterDropdownProps> = ({
  label,
  onChange,
  options,
  dataHook,
  filterByText,
}) => {
  const filterByTitle: FloatingDropdownOptionProps = {
    id: 'filter-by',
    value: filterByText,
  };
  const filterOptions: FloatingDropdownOptionProps[] = options.map(
    ({ id, value, selected }) => ({
      value,
      id,
      icon: (
        <Checkbox
          key={id}
          checked={selected}
          onChange={({ checked }) => onChange({ id, value, selected: checked })}
        />
      ),
    }),
  );

  return (
    <div className={classes.root} data-hook={FilterDropdownDataHooks.Main}>
      <FloatingDropdown
        className={classes.dropdown}
        removeElementMinWidth
        label={label}
        onChange={onChange}
        options={[filterByTitle, ...filterOptions]}
        data-hook={dataHook}
      />
    </div>
  );
};
